import ProfileModal from "./ProfileModal"
import InvestorProjectInvestmentsPage from "./InvestorProjectInvestmentsPage"

export default InvestorProjectInvestmentsPage
export { ProfileModal }
